export function getLocalStorageItem(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        //        
    }
    return null;
}

export function setLocalStorageItem(key, value) {
    try {
        return window.localStorage.setItem(key, value)
    } catch (e) {
        //
    }
    return null;
}